<template>
  <div id="app" @beforeunload="close">
    <loading :loading="loading"></loading>
    <xbTime :loading="loading"></xbTime>
  </div>
</template>

<script>
import xbTime from './components/xbTime';
import loading from './components/loading';

export default {
  name: 'App',
  components: {
    xbTime,
    loading
  },
  data(){
    return {
      loading:true
    }
  },
  methods:{
    close(){
      alert(1)
    }
  },
  created() {
    this.loading=false;
  },
}
</script>

<style>
*{
  margin:0;
  padding:0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue